<div class="page-body">

    <h2 class="center-text">Agent Options</h2>

    <mat-tab-group>
        <!--Overflow Management-------------------------------------------------------------------------------------------------------------------------->
        <mat-tab label="Overflow">

            <br>
            <div class="flex-container space-around">
                <select class="left custom-select" [disabled]="disableLobSelect" [(ngModel)]="lobSelect" (ngModelChange)="applyFilters(lobSelect);">
                    <option class="custom-option" selected ngValue="">All Users</option>
                    <option class="custom-option" *ngFor="let lob of lobList" [ngValue]="lob[1]">{{lob[0]}}</option>
                </select>
            </div>
        
            <div id="responseContainer">
                <app-response-text 
                    class="center-text"
                    [lambdaMessage]="lambdaMessage"
                    [lambdaError]="lambdaError">
                </app-response-text>
            </div>
        
            <div id="tableContainer">
                <app-data-grid
                    [(data)]="filteredData"
                    [objectBluePrint]="bluePrint"
                    [headerTemplate]="header"
                    [viewTemplate]="view"
                    [formTemplate]="form"
                    [columnNames]="['Username', 'LOB', 'Overflow Queue']"
                    [spacing]="[2, 1, 2, 1]"
                    [itemsPerPage]="inputItemsPerPage"
                    [(isValid)]="formValid"
                    (itemChange)="handleItemChange($event);"
                    (buttonEvent)="updateMode($event); lambdaError = false; lambdaMessage = '';"
                    [debug]="false"
                    >
        
                    <ng-template #header>
                        <span>
                            <input class="searchBar" type="text" placeholder="search..." [(ngModel)]="searchString" (ngModelChange)="applyFilters(lobSelect)">
                            <span class="headerText">
                                Total Agents: {{data.length}}
                            </span>
                        </span>
                    </ng-template>
        
                    <ng-template #view let-item>
                        <td><span class="left-text">{{item.userName}}</span></td>
                        <td>{{item.lob}}</td>
                        <td>{{getQueueName(item)}}</td>
                    </ng-template>
            
                    <ng-template #form let-item>
                        <td><input type="text" [disabled]="!newRow" [(ngModel)]="item.userName" (ngModelChange)="formValid = validate(item);"></td>
                        <td>
                            <select class="custom-select" [(ngModel)]="item.lob" (ngModelChange)="formValid = validate(item);">
                                <option class="custom-option" selected hidden ngValue="">Select LOB</option>
                                <option class="custom-option" *ngFor="let lob of lobList" [ngValue]="lob[1]">{{lob[0]}}</option>
                            </select>
                        </td>
                        <td>
                            <!-- (valueChange)="formValid = validate(queue);"
                            (valueSelect)="setUndefinedQueueArn($event, queue); formValid = validate(queue);"  -->
                            <app-combo-box 
                                [(value)]="item.overflowQueue.name"
                                (valueSelect)="formValid = validate(item); setQueueArn($event, item);"
                                [options]="queueNameOptions"
                                [disabled]="false">
                            </app-combo-box>
                        </td>
                    </ng-template>
                    
                </app-data-grid>
            </div>
        </mat-tab>

        <!--Batch Upload-------------------------------------------------------------------------------------------------------------------------->
        <mat-tab label="Overflow Batch">
            <app-overflow-upload></app-overflow-upload>
        </mat-tab>

    </mat-tab-group>

</div>
